import { Link } from "react-router-dom";
import { Send, MessageCircle } from "lucide-react";
import Logo from "@/components/Logo";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useI18n } from "@/context/I18nContext";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { t } = useI18n();
  const { settings } = useSettings();

  const cols = [
    { title: t("footer.services"), links: [
      { to: "/services/tiktok-ads-management", label: "TikTok Ads" },
      { to: "/services/meta-ads-management", label: "Meta Ads" },
      { to: "/services/google-ads-management", label: "Google Ads" },
      { to: "/seo", label: "SEO" },
      { to: "/landing-pages", label: "Landing Pages" },
    ]},
    { title: t("footer.company"), links: [
      { to: "/about", label: t("nav.about") },
      { to: "/testimonials", label: t("nav.testimonials") },
      { to: "/blog", label: t("nav.blog") },
      { to: "/contact", label: t("nav.contact") },
    ]},
    { title: t("footer.support"), links: [
      { to: "/faq", label: t("nav.faq") },
      { to: "/terms", label: t("footer.terms") },
      { to: "/privacy", label: t("footer.privacy") },
      { to: "/refund-policy", label: t("footer.refund") },
    ]},
  ];

  return (
    <footer className="border-t border-amber-500/15 bg-[#0B0C0E] grid-glow" data-testid="site-footer">
      <div className="container-lux py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Logo />
            <p className="mt-4 text-sm text-slate-400 max-w-sm leading-relaxed">
              {settings.footer_text || "ADNEXA DIGITAL is a performance marketing and digital growth agency."}
            </p>
            <div className="flex gap-3 mt-5">
              {settings.telegram && (
                <a href={settings.telegram} target="_blank" rel="noreferrer" className="silver-btn !p-2.5" data-testid="footer-telegram"><Send size={18} /></a>
              )}
              {settings.whatsapp && (
                <a href={settings.whatsapp} target="_blank" rel="noreferrer" className="silver-btn !p-2.5" data-testid="footer-whatsapp"><MessageCircle size={18} /></a>
              )}
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="label-lux mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-sm text-slate-400 hover:text-amber-400 transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">{settings.copyright || "© 2026 ADNEXA DIGITAL. All rights reserved."}</p>
          <LanguageSwitcher compact />
        </div>
      </div>
    </footer>
  );
}
